const cartCn = {
  title: '我的购物袋',
  clearAll: '清空全部',
  itemsInBag: (n) => `购物袋中有 ${n} 件商品`,
  sectionCartItems: '购物袋中的商品',
  continueShopping: '继续购物',
  orderSummary: '订单摘要',
  subtotal: '小计',
  delivery: '配送费',
  free: '免费',
  discount: '折扣',
  total: '总计',
  couponPlaceholder: '输入优惠券代码',
  applyCoupon: '应用优惠券',
  proceedCheckout: '前往结账',
  trust: {
    securePayment: '100% 安全支付',
    fastDelivery: '快速配送',
    cod: '货到付款'
  },
  empty: {
    title: '您的购物袋是空的',
    subtitle: '看起来您还没有添加任何商品。\n浏览我们精美的产品并开始购物吧！',
    cta: '开始购物'
  },
  item: {
    inStock: '有库存',
    removed: '商品已从购物袋中移除'
  },
  cleared: '所有商品已从购物袋中移除'
};

export default cartCn;
